(function () {
  const ACRYLIC_LABEL = 'Framed Print under Matte Acrylic';
  const METAL_LABEL = 'Framed Giclée Print on Metal';
  const CONFIG_OPTION = 'Configuration';
  const FADE_DURATION = 1000; // ms

  function fadeOut(el, cb) {
    el.style.transition = `opacity ${FADE_DURATION}ms ease`;
    el.style.opacity = '0';
    setTimeout(() => {
      el.style.display = 'none';
      el.style.transition = '';
      if (cb) cb();
    }, FADE_DURATION);
  }

  function fadeIn(el) {
    el.style.display = '';
    el.style.opacity = '0';
    el.style.transition = `opacity ${FADE_DURATION}ms ease`;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.opacity = '1';
      });
    });
    setTimeout(() => {
      el.style.transition = '';
    }, FADE_DURATION);
  }

  function setDisplay(el, show, fade) {
    if (!fade) {
      el.style.display = show ? '' : 'none';
      el.style.opacity = show ? '1' : '';
      return;
    }
    const isVisible = el.style.display !== 'none';
    if (show && !isVisible) fadeIn(el);
    if (!show && isVisible) fadeOut(el);
  }

  function updateDescription(selectedConfig, fade) {
    const desc = document.querySelector('.product__description');
    if (!desc) return;

    const allH3s = desc.querySelectorAll('h3');
    const h4s = desc.querySelectorAll('h4');
    if (!allH3s.length || h4s.length < 1) return;

    // Hide only the "Available in..." h3
    allH3s.forEach(h3 => {
      if (h3.textContent.toLowerCase().includes('available')) {
        h3.style.display = 'none';
      }
    });

    h4s.forEach((h4) => {
      const isAcrylic = h4.textContent.toLowerCase().includes('acrylic');
      const isMetal =
        h4.textContent.toLowerCase().includes('metal') ||
        h4.textContent.toLowerCase().includes('gicl');

      const show =
        (isAcrylic && selectedConfig === ACRYLIC_LABEL) ||
        (isMetal && selectedConfig === METAL_LABEL);

      setDisplay(h4, show, fade);

                 let next = h4.nextElementSibling;
      let inPerfectFor = false;
      while (next && next.tagName !== 'H4') {
        if (next.tagName === 'H3') {
          if (next.textContent.toLowerCase().includes('perfect')) {
            inPerfectFor = true;
            next.style.display = ''; // always show
          } else {
            inPerfectFor = false;
            setDisplay(next, show, fade);
          }
        } else if (inPerfectFor) {
          next.style.display = ''; // always show content under "Perfect for"
        } else if (next.tagName === 'UL' || next.tagName === 'P') {
          setDisplay(next, show, fade);
        }
        next = next.nextElementSibling;
      }
    });
  }

  function init() {
    const form = Array.from(document.querySelectorAll('form[action="/cart/add"]')).find(f => f.querySelector('input[name="id"]'));
    if (!form) return;

    let initialConfig = null;
    document.querySelectorAll('input[type="radio"]').forEach((input) => {
      if (
        input.checked &&
        (input.value === ACRYLIC_LABEL || input.value === METAL_LABEL)
      ) {
        initialConfig = input.value;
      }
    });
    if (initialConfig) updateDescription(initialConfig, false);

    document.addEventListener('variant:changed', (e) => {
      const variant = e.detail?.variant;
      if (!variant) return;
      const options = variant.options || [];
      const configIndex = variant.option_names
        ? variant.option_names.indexOf(CONFIG_OPTION)
        : -1;
      const selected = configIndex >= 0 ? options[configIndex] : null;
      if (selected) updateDescription(selected, true);
    });

    document.addEventListener('change', (e) => {
      if (
        e.target.type === 'radio' &&
        (e.target.value === ACRYLIC_LABEL || e.target.value === METAL_LABEL)
      ) {
        updateDescription(e.target.value, true);
      }
    });
  }

  function waitForDescription(cb) {
    const desc = document.querySelector('.product__description');
    if (desc && desc.children.length > 0) {
      cb();
    } else {
      setTimeout(() => waitForDescription(cb), 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForDescription(init));
  } else {
    waitForDescription(init);
  }
})();


